export const expensesEn = {
  title: 'Expenses',
  create: 'New Expense',
  loading: 'Loading...',
  filters: {
    all: 'All',
    draft: 'Draft',
    pending: 'Pending',
    approved: 'Approved',
  },
  emptyTitle: 'No expense claims',
  emptyDesc: 'You have not submitted any expense claims yet',
  emptyAction: 'Create first expense',
  columns: {
    number: 'Expense No.',
    title: 'Title',
    amount: 'Amount',
    status: 'Status',
    createdAt: 'Created At',
    actions: 'Actions',
  },
  actions: {
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
  },
  confirm: {
    deleteTitle: 'Delete this expense claim?',
  },
  error: {
    deleteFailed: 'Delete failed',
  },
  status: {
    DRAFT: 'Draft',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
  },
};

export type ExpensesTranslations = typeof expensesEn;
